import React from 'react';
import {
  StatusBadge,
  toneForEpicState,
  labelForEpicState,
} from '../ui/StatusBadge';

interface StateIndicatorProps {
  /**
   * Epic / story state. Free-form string — Forge emits values outside
   * the WebPortal enum (e.g. `IN_PROGRESS`); we render known values
   * with their semantic colour and fall back to neutral for anything else.
   */
  state: string;
  className?: string;
  /** When true, show the raw Forge state instead of the friendly label. */
  raw?: boolean;
}

export const StateIndicator: React.FC<StateIndicatorProps> = ({ state, className, raw }) => (
  <StatusBadge
    tone={toneForEpicState(state)}
    dot
    className={className ?? ''}
  >
    {raw ? state : labelForEpicState(state)}
  </StatusBadge>
);
